import type { IntlShape } from 'react-intl'

export default function getAgentHubPhonePlaceholder(intl: IntlShape, region: string) {
  switch (region) {
    case 'GB':
      return intl.formatMessage({
        id: 'FYxrrOiajqZhlNDz4PDD',
        defaultMessage: '07000 000 000',
        description: 'Example phone number placeholder shown for United Kingdom agents in the expression of interest form',
      })
    default:
      return intl.formatMessage({
        id: '5dJ2GPEOfdRSoJ_-n1J8',
        defaultMessage: '0400 000 000',
        description: 'Example phone number placeholder shown for non-United-Kingdom agents in the expression of interest form',
      })
  }
}
